import { Headline as HeadlineProps, SanityKeyed } from 'types/studio/studio';
import { Typography } from '@ag1/ui';
import { useEffect } from 'react';
import { useProductStore } from '@portal/state/store/pdpStore';

import { CustomPortableText } from '../../PortableText';
import { CommonSectionProps } from '../../types';
import styles from './Headline.module.scss';

const Headline = (props: SanityKeyed<HeadlineProps> & CommonSectionProps) => {
  const { _key: key, headline, subtitle } = props;
  const setSelectedPdpProductTitle = useProductStore((state) => state.setSelectedPdpProductTitle);
  const selectedFlavorSubtitle = useProductStore((state) => state.flavorSubtitle);

  useEffect(() => {
    const headlineText = headline
      ?.map((block) => block.children.map((child: { text: any }) => child.text).join(''))
      .join(' ');
    setSelectedPdpProductTitle(headlineText);
  }, [setSelectedPdpProductTitle, headline]);

  return (
    <div id={key}>
      <Typography variant="headline" size="2" className={styles.headline} noPadding>
        <CustomPortableText value={headline} tag="h1" />
      </Typography>
      <Typography variant="subtitle" size="2" className={styles.subtitle} noPadding>
        {selectedFlavorSubtitle || <CustomPortableText value={subtitle} />}
      </Typography>
    </div>
  );
};

export default Headline;
